import { formatDateTime, parseUtcMs } from "@/utils/datetime";
import { Text, TruncatedText, type DataTableColumn } from "@carbon6/c6-frontend-design";
import { hatcheryTextModes } from "@/app/theme";
import { HatLabelChip } from "@/components/label";
import type { LabelTableRow } from "./LabelTableRow";
import { formatLabelText } from "./labelFormatters";
import styles from "./LabelPage.module.css";

export const labelColumns: readonly DataTableColumn<LabelTableRow>[] = [
  {
    key: "value",
    header: "라벨",
    width: "280px",
    // 칩 툴팁은 옆 설명 컬럼과 같은 문구여야 한다. 그래서 서버 설명을 그대로 전달한다.
    render: (label) => (
      <HatLabelChip
        labelKey={label.key}
        value={label.value}
        color={label.color}
        description={label.description}
        size="sm"
      >
        {formatLabelText(label)}
      </HatLabelChip>
    ),
  },
  {
    key: "description",
    header: "설명",
    width: "minmax(220px, 1fr)",
    // c6 는 render/format 이 없는 컬럼에만 잘림 마커를 붙인다. 이 셀은 직접 그리므로 마커를 직접
    // 달아야 잘린 설명을 hover 로 볼 수 있다. 다른 컬럼과 달리 Text 로 감싸지 않는 이유: 마커는
    // 실제로 잘리는 요소와 같은 요소여야 하고, 타이포는 c6 가 셀에 적용한 `.cellContent` Text 에서
    // 이미 상속된다.
    render: (label) => (
      <TruncatedText className={styles.description}>{label.description ?? "-"}</TruncatedText>
    ),
  },
  {
    key: "usage",
    header: "쓰이는 곳",
    width: "170px",
    // 결함 26개가 두 축(에피소드 리뷰, 데이터셋 판정)에 걸쳐 있다. 표에서는 한 목록이라, 이 컬럼이
    // 없으면 어느 값을 에피소드에서 고를 수 있는지 알 수 없다. 결함 축이 아닌 라벨은 빈 칸이다.
    render: (label) => (
      <Text variant={hatcheryTextModes["body-normal"]} className={styles.description}>
        {label.usage ?? "-"}
      </Text>
    ),
  },
  {
    key: "managed",
    header: "관리됨",
    width: "120px",
    render: (label) =>
      label.managed ? (
        <Text variant={hatcheryTextModes["caption-bold"]} className={styles.statusPill}>
          관리됨
        </Text>
      ) : (
        <Text variant={hatcheryTextModes["body-normal"]} className={styles.description}>
          -
        </Text>
      ),
  },
  {
    key: "modified_at",
    header: "수정일",
    width: "180px",
    format: (value) => formatDateTime(parseUtcMs(String(value))),
  },
];
